import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/info-inquiries', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/info-inquiries/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/info-inquiries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/info-inquiries/${data.inquiry_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/info-inquiries/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const nationality = (Options = {}) => {
  return httpClient
    .get('/api/info-inquiries/nationalities')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const mainProgram = (Options = {}) => {
  return httpClient
    .get('/api/info-inquiries/main-programs', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const subProgram = (acp_id, Options = {}) => {
  if (acp_id === null || acp_id === undefined) return
  return httpClient
    .get(`/api/info-inquiries/${acp_id}/sub-programs`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const studyTime = (Options = {}) => {
  return httpClient
    .get('/api/info-inquiries/study-times', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const province = (Options = {}) => {
  return httpClient
    .get('/api/info-inquiries/provinces')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const district = (province_code, Options = {}) => {
  return httpClient
    .get(`/api/info-inquiries/${province_code}/districts`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const commune = (district_code, Options = {}) => {
  return httpClient
    .get(`/api/info-inquiries/${district_code}/communes`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const village = (commune_code, Options = {}) => {
  return httpClient
    .get(`/api/info-inquiries/${commune_code}/villages`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  nationality,
  mainProgram,
  subProgram,
  studyTime,
  province,
  district,
  commune,
  village
}
